import { Button } from '@src/design-system/button';
import { Logo } from '@shared/assets/icons/shared/logo';

const Navbar = () => {
  return (
    <header className='flex bg-white py-3 shrink-0 items-center gap-2 transition-[width,height] ease-linear shadow-md md:px-20 relative z-20'>
      <div className='flex w-full justify-between items-center gap-2 px-4'>
        <Logo
          open={true}
          dark={true}
        />
        <div>
          <Button
            variant='primary'
            size='sm'
          >
            contact us
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
